import React, {useEffect, useState} from "react";
import {FormControlLabel, FormGroup, IconButton, Switch, Typography} from "@mui/material";
import css_buttons from "../components/Common/css/CCButton.module.scss";
import {Refresh} from "@mui/icons-material";
import {Grey6} from "../theme/styles";
import ETLJobTableApplet from "../eoec/applet/impl/ETLJob/ETLJobTableApplet";
import enterpriseObjectClassFactory from "../eoec/EnterpriseObjectClassFactory";
import EnterpriseObject from "../eoec/eo/EnterpriseObject";
import {makeEnterpriseComponent} from "../util/utility";
import EnterpriseComponent from "../eoec/ec/EnterpriseComponent";
import spinner from "../assets/Spinner-1s-200px.svg";
import moment from "moment-timezone";
import {formatLocalTime} from "../util/Formatters";
import ETLJobExecutionTableApplet from "../eoec/applet/impl/ETLJob/ETLJobExecutionTableApplet";


export default function Dashboard() {
    const [runningEnterpriseComponent] = useState(makeEnterpriseComponent("ETLJobExecution"));
    const [succeededEnterpriseComponent] = useState(makeEnterpriseComponent("ETLJobExecution"));
    const [failedEnterpriseComponent] = useState(makeEnterpriseComponent("ETLJobExecution"));

    const [etlJobEnterpriseObject] = useState(enterpriseObjectClassFactory("ETLJob") as EnterpriseObject);
    const [runningBackgroundOperation, setRunningBackgroundOperation] = useState<boolean>(false);
    const [succeededBackgroundOperation, setSucceededBackgroundOperation] = useState<boolean>(false);
    const [failedBackgroundOperation, setFailedBackgroundOperation] = useState<boolean>(false);
    const [autoRefresh, setAutoRefresh] = useState<boolean>(true);
    const [timeoutID, setTimeoutID] = useState<number>(-1);

    const [refreshDatetime, setRefreshDatetime] = useState<any>(moment.now());

    const [runningCount, setRunningCount] = useState<number>(0);
    const [succeededCount, setSucceededCount] = useState<number>(0);
    const [failedCount, setFailedCount] = useState<number>(0);

    function enterpriseComponentLoadStartedListener(ec: EnterpriseComponent) {
        if (ec.getSerialNumber() === runningEnterpriseComponent.getSerialNumber()) {
            setRunningBackgroundOperation(true);
        } else if (ec.getSerialNumber() === succeededEnterpriseComponent.getSerialNumber()) {
            setSucceededBackgroundOperation(true);
        } else if (ec.getSerialNumber() === failedEnterpriseComponent.getSerialNumber()) {
            setFailedBackgroundOperation(true);
        }
    }

    function enterpriseComponentLoadCompletedListener(ec: EnterpriseComponent) {
        if (ec.getSerialNumber() === runningEnterpriseComponent.getSerialNumber()) {
            setRunningCount(ec.getAttributeValue("Counter"));
            setRunningBackgroundOperation(false)
        } else if (ec.getSerialNumber() === succeededEnterpriseComponent.getSerialNumber()) {
            setSucceededCount(ec.getAttributeValue("Counter"));
            setSucceededBackgroundOperation(false)
        } else if (ec.getSerialNumber() === failedEnterpriseComponent.getSerialNumber()) {
            setFailedCount(ec.getAttributeValue("Counter"));
            setFailedBackgroundOperation(false)
        }
    }

    function refresh() {
        runningEnterpriseComponent.newQuery();
        runningEnterpriseComponent.setIDOCResponse("v1.ETLJobExecution-003");
        runningEnterpriseComponent.executeQuery(1, 1);

        succeededEnterpriseComponent.newQuery();
        succeededEnterpriseComponent.setIDOCResponse("v1.ETLJobExecution-004");
        succeededEnterpriseComponent.executeQuery(1, 1);

        failedEnterpriseComponent.newQuery();
        failedEnterpriseComponent.setIDOCResponse("v1.ETLJobExecution-005");
        failedEnterpriseComponent.executeQuery(1, 1);

        setRefreshDatetime(moment.now())

        if (autoRefresh) {
            // @ts-ignore
            setTimeoutID(setTimeout(refresh, 60 * 1000))
        } else {
            clearTimeout(timeoutID);
        }
    }

    useEffect(() => {
        etlJobEnterpriseObject.getEnterpriseComponent("ETLJob")?.setIDOCRequest("v1.ETLJob-001");
        etlJobEnterpriseObject.getEnterpriseComponent("ETLJob")?.setIDOCResponse("v1.ETLJob-001");

        runningEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        runningEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        failedEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        failedEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        succeededEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        succeededEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);

        refresh();

        // @ts-ignore
        setTimeoutID(setTimeout(refresh, 60 * 1000))

        return () => {
            runningEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener);
            runningEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener)
            succeededEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener);
            succeededEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener)
            failedEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener);
            failedEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener)
        }
    }, [etlJobEnterpriseObject]);

    function renderDashboard() {
        return (
           <div style={{display: "flex", flexDirection: "column", margin: "20px 20px 20px 20px"}}>
               <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: "60px"}}>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                        <FormGroup>
                            <FormControlLabel style={{whiteSpace: "nowrap"}} control={<Switch checked={autoRefresh} defaultChecked onChange={() => {
                                setAutoRefresh(!autoRefresh);
                                if (!autoRefresh) {
                                    // @ts-ignore
                                    setTimeoutID(setTimeout(refresh, 60 * 1000))
                                } else {
                                    clearTimeout(timeoutID);
                                }
                            }}/>} label="Auto-refresh" />
                        </FormGroup>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                        <div style={{display: "flex", flexDirection: "row", paddingTop: "9px"}}>
                            <div style={{marginRight: "10px"}}>
                                <Typography style={{margin: "8px 0 0 0", fontSize: "14px", fontWeight: 400, color: Grey6}}>Dashboard last refreshed: {formatLocalTime(refreshDatetime)}. {autoRefresh ? "Auto-refreshes every 60 seconds." : null} </Typography>
                            </div>
                        </div>
                    </div>
                </div>
               <div style={{display: "flex", flexDirection: "column", height: "220px"}}>
                   <div style={{display: "flex", flexDirection: "row", width: "100%", height: "40px", justifyContent: "space-between", marginTop: "20px", paddingBottom: "10px"}}>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", paddingTop: "5px"}}>
                            <Typography style={{fontSize: 22, fontWeight: 500, color: "#1498D8"}}>Jobs Overview</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                            <IconButton className={css_buttons.blueOutlinedButton} style={{border: "1px solid #1498D8", padding: "0 5px 0 5px"}} sx={{width: "35px", height: "35px"}} onClick={() => {refresh()}}>
                                <Refresh />
                            </IconButton>
                        </div>
                   </div>
                   <div style={{display: "flex", flexDirection: "row", width: "100%", justifyContent: "space-between", border: "1px solid #D8DDE4", borderRadius: "20px"}}>
                       <div style={{display: "flex", flexDirection: "row", justifyContent: "center", width: "25%", borderRight: "1px solid #D8DDE4", padding: "20px 20px 20px 20px"}}>
                           <div style={{display: "flex", flexDirection: "column", alignContent: "center"}}>
                               <Typography style={{fontSize: 18, fontWeight: 350, color: "#000000", margin: "0 auto 0 auto"}}>Runnable</Typography>
                               <Typography style={{fontSize: 50, fontWeight: 400, color: "#000000", margin: "0 auto 0 auto"}}>0</Typography>
                           </div>
                       </div>
                       <div style={{display: "flex", flexDirection: "row", justifyContent: "center", width: "25%", borderRight: "1px solid #D8DDE4", padding: "20px 20px 20px 20px"}}>
                           <div style={{display: "flex", flexDirection: "column", alignContent: "center"}}>
                               <Typography style={{fontSize: 18, fontWeight: 350, color: "#000000", margin: "0 auto 0 auto"}}>Running</Typography>
                               {runningBackgroundOperation ? (
                                   <img width="75" height="75" src={spinner} alt="spinner" />
                               ) : (
                                   <Typography style={{fontSize: 50, fontWeight: 400, color: "#000000", margin: "0 auto 0 auto"}}>{runningCount}</Typography>
                               )}
                           </div>
                       </div>
                       <div style={{display: "flex", flexDirection: "row", justifyContent: "center", width: "25%", borderRight: "1px solid #D8DDE4", padding: "20px 20px 20px 20px"}}>
                           <div style={{display: "flex", flexDirection: "column", alignContent: "center"}}>
                               <Typography style={{fontSize: 18, fontWeight: 350, color: "#000000", margin: "0 auto 0 auto"}}>Succeeded</Typography>
                               {succeededBackgroundOperation ? (
                                   <img width="75" height="75" src={spinner} alt="spinner" />
                               ) : (
                                   <Typography style={{fontSize: 50, fontWeight: 400, color: "#000000", margin: "0 auto 0 auto"}}>{succeededCount}</Typography>
                               )}
                           </div>
                       </div>
                       <div style={{display: "flex", flexDirection: "row", justifyContent: "center", width: "25%", padding: "20px 20px 20px 20px"}}>
                           <div style={{display: "flex", flexDirection: "column", alignContent: "center"}}>
                               <Typography style={{fontSize: 18, fontWeight: 350, color: "#000000", margin: "0 auto 0 auto"}}>Failed</Typography>
                               {failedBackgroundOperation ? (
                                   <img width="75" height="75" src={spinner} alt="spinner" />
                               ) : (
                                   <Typography style={{fontSize: 50, fontWeight: 400, color: "#000000", margin: "0 auto 0 auto"}}>{failedCount}</Typography>
                               )}
                           </div>
                       </div>
                   </div>
               </div>
               <div style={{margin: "30px 0 0 0"}}>
                    <ETLJobTableApplet enterpriseComponent={etlJobEnterpriseObject?.getEnterpriseComponent("ETLJob")}/>
               </div>
               <div style={{margin: "30px 0 0 0"}}>
                    <ETLJobExecutionTableApplet enterpriseComponent={etlJobEnterpriseObject?.getEnterpriseComponent("ETLJobExecution")}/>
               </div>
           </div>
        )
    }

    return (
        <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#1498D8"}}>
                <div style={{paddingTop: "9px", paddingLeft: "20px"}}>
                    <Typography style={{fontSize: 24, fontWeight: 400, color: "#FFFFFF"}}>Dashboard</Typography>
                </div>
            </div>
            {renderDashboard()}
        </div>
    );
}